/* The Gorgias launcher is an app-owned same-origin srcdoc iframe. Style only
   its launcher document; never replace its button, handlers, or chat panel. */
(() => {
  const frameStyles = `
    html,body{margin:0!important;padding:0!important;background:transparent!important;overflow:hidden!important}
    #gorgias-chat-messenger-button{box-sizing:border-box!important;width:56px!important;height:56px!important;margin:0!important;padding:0!important;border:0!important;border-radius:50%!important;background:#000!important;color:#fff!important;box-shadow:none!important;transform:none!important}
    #gorgias-chat-messenger-button>div{background:none!important;box-shadow:none!important;width:56px!important;height:56px!important;inset:0!important;transform:none!important}
    #gorgias-chat-messenger-button svg{color:#fff!important;width:28px!important;height:28px!important}
    #gorgias-chat-messenger-button svg [stroke]:not([stroke="none"]){stroke:#fff!important}
    #gorgias-chat-messenger-button svg [fill]:not([fill="none"]){fill:#fff!important}
    #gorgias-chat-messenger-button:focus-visible{outline:2px solid #fff!important;outline-offset:-5px!important}
  `;
  function styleFrame(frame) {
    try {
      const doc = frame.contentDocument;
      if (!doc?.head || doc.getElementById('wave-launcher-style')) return;
      const style = doc.createElement('style');
      style.id = 'wave-launcher-style'; style.textContent = frameStyles;
      doc.head.appendChild(style);
    } catch (_) { /* Do not interfere if the app changes to a cross-origin frame. */ }
  }
  function bind() {
    const frame = document.getElementById('chat-button');
    if (!frame) return;
    if (!frame.dataset.waveLauncherBound) {
      frame.dataset.waveLauncherBound = 'true';
      frame.addEventListener('load', () => styleFrame(frame));
    }
    styleFrame(frame);
  }
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; bind(); });
  }).observe(document.body, { childList:true, subtree:true });
  bind();
})();
